/**
 * Surface — the JobType-level axis separating standard capture jobs from
 * remittance jobs (SP1 foundation design 2026-07-09 §2/§5). NOT the
 * "config surfaces" (Processing Config vs Form Config pages) — that sense
 * stays prose-only; in code, JobType.surface is the only `surface` axis.
 */
export const SURFACES = ['standard', 'remittance'];
export function surfaceAllows(item, surface) {
    return !item.surfaces || item.surfaces.includes(surface);
}
export function filterBySurface(items, surface) {
    return items.filter((i) => surfaceAllows(i, surface));
}
//# sourceMappingURL=surfaces.js.map